// src/pages/chat/CTA/cta.styled.ts
import styled from "@emotion/styled";

export const Btn = styled.button`
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    border-radius: 999px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    background: transparent;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    z-index: 1;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.55;
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid rgba(94, 132, 237, 0.85);
        outline-offset: 4px;
    }
`;

export const VideoStack = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    overflow: hidden;
`;

export const VideoEl = styled.video`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    display: block;

    border-radius: inherit;
    object-fit: cover;
    pointer-events: none;
    background: transparent;

    /* crossfade — slow morph so phase transitions feel like a transformation */
    opacity: 0;
    transition: opacity 500ms cubic-bezier(0.4, 0, 0.2, 1);
    will-change: opacity;

    &[data-active="true"] {
        opacity: 1;
        transition: opacity 400ms cubic-bezier(0.0, 0, 0.2, 1);
    }
`;
